import React from 'react'
import { EyeIcon, EyeOffIcon } from 'lucide-react'

import { Input } from 'src/components/shadcn/input'
import { usePasswordInput } from 'src/components/PasswordInput/usePasswordInput'
import { PasswordInputProps } from 'src/components/PasswordInput/types'

const PasswordInput = ({ placeholder, formField }: PasswordInputProps) => {
  const { togglePasswordVisibility, showPassword } = usePasswordInput()

  return (
    <div className="relative">
      <Input
        type={showPassword ? 'text' : 'password'}
        placeholder={placeholder}
        {...formField}
      />
      <button
        type="button"
        onClick={togglePasswordVisibility}
        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-sm text-gray-600"
      >
        {showPassword ? (
          <EyeOffIcon className="w-4 h-4" />
        ) : (
          <EyeIcon className="w-4 h-4" />
        )}
      </button>
    </div>
  )
}

export default PasswordInput
